import { computed } from 'vue'
import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import en from './en'

export type MessageSchema = typeof zhCN
export type SupportedLocale = 'zh-CN' | 'en'

const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    en,
  },
})

function detectLocale(): SupportedLocale {
  const saved = localStorage.getItem('locale')
  if (saved === 'en' || saved === 'zh-CN') {
    return saved
  }
  const browserLang = navigator.language.toLowerCase()
  return browserLang.startsWith('zh') ? 'zh-CN' : 'en'
}

export function setLocale(locale: SupportedLocale) {
  ;(i18n.global.locale as unknown as { value: SupportedLocale }).value = locale
  localStorage.setItem('locale', locale)
  document.documentElement.lang = locale === 'zh-CN' ? 'zh' : 'en'
}

export function useTranslation() {
  const locale = computed<SupportedLocale>({
    get: () => i18n.global.locale as unknown as SupportedLocale,
    set: (val: SupportedLocale) => setLocale(val),
  })
  return {
    t: i18n.global.t,
    locale,
    setLocale,
  }
}

export default i18n
